// extracted by mini-css-extract-plugin
module.exports = {"root":"Parallax-module--root--2jkrc","child":"Parallax-module--child--2clA2"};